import { AuthData, Claims, User } from '@keyliving/shared-types';

import { authApi } from '../api/apiModule';
import { ForgotPasswordParams, MagicLinkParams, SignInParams } from './types';

export const authService = authApi.injectEndpoints({
    endpoints: (builder) => ({
        forgotPassword: builder.mutation<string, ForgotPasswordParams>({
            query: ({ email, linkParams }) => ({
                url: '/users/request-password-reset',
                method: 'PUT',
                body: { email: email.toLowerCase().trim(), linkParams },
            }),
        }),
        magicLogin: builder.mutation<void, MagicLinkParams>({
            query: ({ email, linkParams, orgCode }) => ({
                url: '/users/magic-login',
                method: 'POST',
                body: {
                    email: email.toLowerCase().trim(),
                    linkParams,
                    orgCode,
                },
            }),
        }),
        me: builder.query<User, void>({
            query: () => ({
                url: '/users/me',
                method: 'GET',
            }),
            transformResponse: (res: { user: User }) => {
                return res.user;
            },
            providesTags: (result, error, id) => {
                return [{ type: 'User', id: 'me' }];
            },
        }),
        newPassword: builder.mutation<string, { password: string; token: string }>({
            query: (body) => ({
                url: '/users/password-reset',
                method: 'PUT',
                body,
            }),
        }),
        signin: builder.mutation<AuthData, SignInParams>({
            query: (body) => ({
                url: '/users/authenticate',
                method: 'POST',
                body,
            }),
        }),
        verifyAuthToken: builder.query<Claims, string>({
            query: (token) => ({
                url: '/users/verify',
                method: 'POST',
                body: { token },
            }),
            transformResponse: (res: { claims: Claims }) => {
                return res.claims;
            },
        }),
    }),
});

// auto-generated based on the defined endpoints
export const {
    useForgotPasswordMutation,
    useLazyMeQuery,
    useLazyVerifyAuthTokenQuery,
    useMagicLoginMutation,
    useNewPasswordMutation,
    useSigninMutation,
} = authService;
